import { AlertService } from '@/common/services/alert/alert.service';
import { ValidationService } from '@/common/services/validation/validation.service';
import { ContactFormInformationResponse } from '@/core/domain/customer-support/models/ContactFormInformationResponse-response.model';
import { GetContactFormInformationUseCase } from '@/core/domain/customer-support/usecases/getContactFormInformation.usecase';
import { SendFormUseCase } from '@/core/domain/customer-support/usecases/sendForm.usecase';
import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SwalComponent, SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2';
import { catchError, throwError } from 'rxjs';

@Component({
    selector: 'fe-customer-support',
    templateUrl: './customer-support.component.html',
    styleUrls: ['./customer-support.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CustomerSupportComponent {
    public formContactSupport!: FormGroup;

    public loadingBtnSendMessage = false;

    public topics: any[] = [];

    public rentalOffices: any[] = [];

    @ViewChild('formContactTemplate') formContactTemplate!: SwalComponent;

    constructor(
        public readonly swalTargets: SwalPortalTargets,
        private readonly formBuilder: FormBuilder,
        private readonly validation: ValidationService,
        private readonly sendFormUseCase: SendFormUseCase,
        private readonly getContactFormInformationUseCase: GetContactFormInformationUseCase,
        private readonly alert: AlertService,
        @Inject('RECAPTCHA_SITE_KEY') public recaptchaSiteKey: string,
    ) {
        this.initFormContactSupport();
        this.initContactFormInformation();
    }

    private initContactFormInformation(): void {
        this.getContactFormInformationUseCase
            .execute()
            .subscribe(
                (
                    contactFormInformationResponse: ContactFormInformationResponse,
                ) =>
                    this.onGetContactFormInformation(
                        contactFormInformationResponse,
                    ),
            );
    }

    private onGetContactFormInformation(
        contactFormInformationResponse: ContactFormInformationResponse,
    ): void {
        this.topics = contactFormInformationResponse.data.topics as {
            [key: string]: unknown;
        }[];
        this.rentalOffices = contactFormInformationResponse.data
            .rentalOffices as {
            [key: string]: unknown;
        }[];
    }

    private initFormContactSupport(): void {
        this.formContactSupport = this.formBuilder.group({
            name: ['', Validators.compose([Validators.required])],
            lastName: ['', Validators.compose([Validators.required])],
            email: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validation.validEmail,
                ]),
            ],
            rentalOffice: ['', Validators.compose([Validators.required])],
            topic: ['', Validators.compose([Validators.required])],
            comments: ['', Validators.compose([Validators.required])],
            /*recaptchaToken: ['', Validators.compose([Validators.required])],*/
        });
    }

    public breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_customer_support',
            url: 'contact-us-and-faqs',
        },
    ];

    public onClickOpenContactForm(): void {
        this.formContactTemplate.fire();
        this.formContactTemplate.didDestroy.subscribe(() => {
            this.formContactSupport.reset();
        });
    }

    public onClickSendMessage(): void {
        this.formContactSupport.markAllAsTouched();

        if (!this.formContactSupport.valid) {
            return;
        }

        this.loadingBtnSendMessage = true;

        this.sendFormUseCase
            .execute(this.formContactSupport.value)
            .pipe(
                catchError((error) => {
                    this.alert.openDefault(error);
                    return throwError(() => error);
                }),
            )
            .subscribe(() => this.onResponseSendForm());
    }

    private onResponseSendForm(): void {
        this.loadingBtnSendMessage = false;
        this.formContactTemplate.close();
    }
}
